import { NAVIGATION_TRANSLATION } from './navigation';
import { ADMINS_TRANSLATION } from './admins';
import { CLIENTS_TRANSLATION } from './clients';
import { COMPANIES_TRANSLATION } from './companies';
import { USERS_TRANSLATION } from './users';
import { CALCULATIONS_TRANSLATION } from './calculations';
import { DOCUMENTS_TRANSLATION } from './documents';
import { SHARED_TRANSLATION } from './shared';
import { HISTORICAL_MODULE_TRANSLATION } from './historicalModule';
import { NOTIFICATIONS_TRANSLATIONS } from './notifications';
export const TRANSLATIONS_RO = {
    ...NAVIGATION_TRANSLATION,
    ...ADMINS_TRANSLATION,
    ...CLIENTS_TRANSLATION,
    ...COMPANIES_TRANSLATION,
    ...USERS_TRANSLATION,
    ...CALCULATIONS_TRANSLATION,
    ...DOCUMENTS_TRANSLATION,
    ...SHARED_TRANSLATION,
    ...HISTORICAL_MODULE_TRANSLATION,
    ...NOTIFICATIONS_TRANSLATIONS
};
